import React, { FunctionComponent } from 'react'
import { CheckboxContainer, HiddenCheckbox, StyledCheckbox } from './style'
import CheckIcon from '@material-ui/icons/Check';

type CheckboxProps = {
    checked: boolean,
    disabled?: boolean,
    color: string,
    onChange: () => void
}

const Checkbox: FunctionComponent<CheckboxProps> = ({ checked, color, onChange, disabled = false }) => (
    <CheckboxContainer disabled={disabled}>
        <HiddenCheckbox checked={checked} onChange={onChange} />
        <StyledCheckbox checked={checked} color={color} onClick={onChange}>
            <CheckIcon
                style={{
                    color:'#fff',
                    width: '13px',
                    marginTop: '-7px',
                    marginLeft: '-1px'
                }}
                viewBox="0 0 24 24"
            />
        </StyledCheckbox>
    </CheckboxContainer>
)

export default Checkbox
